import { useContext, useMemo } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const useClientNameColumn = () => {
  const { t } = useContext(ConfigContext);

  return useMemo(
    () => ({
      field: 'clientName',
      headerName: t('client'),
      flex: 2.5,
      initialHide: true,
      sortable: false
    }),
    [t]
  );
};

export default useClientNameColumn;
